import styles from '@/styles/About.module.css'
import Head from 'next/head'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import HomeImage from '/public/img/Home.webp'
import { useTranslation } from 'react-i18next'

const BurgareSmash = dynamic(() => import('@/components/BurgareSmash'))

const Page = () => {
  const { t } = useTranslation()

  const generateMissingImage = (width, height, alt) => {
    if (
      !width ||
      !height ||
      typeof width !== 'number' ||
      typeof height !== 'number'
    ) {
      return (
        <Image
          src={HomeImage}
          className={styles.imageUrl}
          width={200}
          height={100}
          alt={alt || 'Image Not Available'}
          loading='lazy'
        />
      ) // or some default image URL
    }
    return (
      <Image
        src={`https://via.placeholder.com/${width}x${height}`}
        width={width}
        height={height}
        alt={alt || 'Image Not Available'}
        loading='lazy'
      />
    )
  }

  const itemList = [
    {
      name: 'Jalapeño Burger',
      description: t('A classic hamburger with a spicy kick, weighing 90g.'),
      image: '/baconBurger.webp',
      recipeIngredient: [
        'Brioche bread',
        'Cheddar cheese',
        'Crispy salad',
        'Jalapeño',
        'Chilli cheese',
        'Chilli mayonnaise',
        'Ground beef: 100g',
      ],
    },
    {
      name: 'Truffle Burger',
      description: t(
        'A hearty hamburger infused with the aroma of truffles, weighing 150g.'
      ),
      image: '/tryffelBurgare.webp',
      recipeIngredient: [
        'Brioche bread',
        'Cheddar cheese',
        'Crisp salad',
        'Onion rings',
        'Truffle mayonnaise',
        'Ground beef: 100g',
      ],
    },
    {
      name: 'Bacon Burger',
      description: t(
        'A substantial hamburger topped with crispy bacon, weighing 200g.'
      ),
      image: '/baconBurger.webp',
      recipeIngredient: [
        'Brioche bread',
        'Crispy salad',
        'Cheddar cheese',
        'Bacon',
        'Onion rings',
        'Mayonnaise',
        'Ground beef: 100g',
      ],
    },
    {
      name: 'BBQ Bacon Burger',
      description: t(
        'A juicy chicken burger with smoky BBQ flavors, weighing 140g.'
      ),
      image: '/baconBurger.webp',
      recipeIngredient: [
        'Brioche bread',
        'Crispy salad',
        'Cheddar cheese',
        'Bacon',
        'BBQ sauce',
        'Ground chicken: 100g',
      ],
    },
    {
      name: 'Halloumi Burger',
      description: t(
        'A vegetarian delight featuring grilled halloumi and fresh vegetables.'
      ),
      image: '/hallomiBurgare.webp',
      recipeIngredient: [
        'Brioche bread',
        'Fried halloumi',
        'Crisp salad',
        'Tomato',
        'Chilli mayonnaise',
        'Pickled cucumber',
        'Red onion',
      ],
    },
  ]

  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Smashburgare Meny</title>
        <meta
          name='description'
          content="Prepare for a flavor explosion with our delicious smashburgers! 🍔 Our high-quality burgers are made with finely ground beef and cooked at high heat until crispy and juicy. Each bite is a burst of flavors that will leave you craving for more. 🤤 Top your burger with your favorite toppings and enjoy an incredible meal that you won\'t forget!"
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: itemList.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                  '@type': 'Recipe',
                  name: item.name,
                  image: item.image,
                  description: item.description,
                  recipeIngredient: item.recipeIngredient,
                },
              })),
            }),
          }}
        />
      </Head>
      <BurgareSmash />
    </main>
  )
}

export default Page
